import { useCurrentUserImage } from '@/hooks/useCurrentUserImage'
import { useCurrentUserName } from '@/hooks/useCurrentUserName'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

interface CurrentUserAvatarProps {
  className?: string;
}

export function CurrentUserAvatar({ className }: CurrentUserAvatarProps) {
  const profileImage = useCurrentUserImage()
  const name = useCurrentUserName()
  const initials = name
    ?.split(' ')
    ?.map((word) => word[0])
    ?.join('')
    ?.toUpperCase() || '?'

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Avatar className={cn("transition-all duration-300 hover:scale-110", className)}>
            {profileImage && (
              <AvatarImage 
                src={profileImage} 
                alt={name || 'Avatar utilisateur'} 
                onError={(e) => {
                  // Silencieusement masquer l'image en cas d'erreur de chargement
                  e.currentTarget.style.display = 'none';
                }}
              />
            )}
            <AvatarFallback className="bg-gradient-to-br from-primary to-primary/80 text-primary-foreground font-semibold">
              {initials}
            </AvatarFallback>
          </Avatar>
        </TooltipTrigger>
        <TooltipContent className="tooltip-modern">
          <p>{name || 'Utilisateur'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
} 